import { gql } from 'graphql-request'

export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($id: Int!) {
    deleteCampaign(id: $id) {
      message
    }
  }
`
